/**
 * Datos públicos de Contabi RD.
 *
 * Están aquí, en un solo sitio, porque son los que aparecen repetidos por toda la web pública
 * (sello de la DGII, footer, página de contacto). Cuando cambie el RNC o un correo, se cambia una
 * vez y no hay que ir a buscarlo por las páginas.
 */

/** RNC de Contabi, sin formato. */
export const RNC = '133426481';

/** El mismo RNC con la separación en que lo escribe la DGII: 1-33-42648-1. */
export const RNC_FORMATTED = '1-33-42648-1';

/**
 * Si el RNC se enseña en la web (portada, sello de la DGII, footer, contacto, nosotros, planes,
 * demo y la ficha de pago). Está apagado a petición del dueño: el RNC no debe quedar visible al
 * público. Para volver a mostrarlo basta con ponerlo en `true`.
 */
export const MOSTRAR_RNC = false;

export const RAZON_SOCIAL = 'Contabi RD';
export const SITIO_WEB = 'https://www.contabird.com';

/** Domicilio público del comercio para contratos, pagos y comunicaciones. */
export const DIRECCION_COMERCIO = {
  /** Domicilio permanente del comercio, el que respalda el RNC. Lo exigen las marcas de tarjeta. */
  linea1: 'Plaza Florida 2, segundo nivel, local 201, calle Laureano Canto',
  ciudad: 'San Pedro de Macorís',
  pais: 'República Dominicana',
};

/**
 * Correos de contacto. Un valor vacío hace que su tarjeta NO se muestre: es preferible una página
 * con menos vías de contacto que una que anuncie un canal que nadie atiende.
 */
export const CONTACTO = {
  soporte: 'info@contabird.com',
  ventas: 'info@contabird.com',
  ecf: 'info@contabird.com',
  /** Formato internacional para el enlace `tel:` / WhatsApp. Vacío = no se muestra. */
  telefono: '809 742 2436',
  whatsapp: '',
  horario: 'Lunes a viernes, 8:00 a. m. – 6:00 p. m. (hora de Santo Domingo)',
};

/** Activos entregados por el comercio para la revisión de la pasarela de pago. */
export const MARCAS_PAGO = {
  visa: '/Visa-Logo-2005.jpg',
  mastercard: '/mastercard-logo.jpg',
};

/**
 * Sellos de autenticación 3-D Secure: Visa Secure y Mastercard ID Check.
 *
 * No son las marcas de tarjeta —esas son `MARCAS_PAGO`—, sino la promesa de que el cobro pasa por
 * la verificación del emisor. Van donde el tarjetahabiente decide pagar, no como adorno: si algún
 * día el cobro dejara de hacerse por la Página de Pago de AZUL (que sí trae 3DS), estos sellos hay
 * que retirarlos.
 */
export const SELLOS_3DS = {
  visaSecure: '/visa-secure.png',
  mastercardIdCheck: '/mastercard-id-check.png',
};

/**
 * Texto del sello de la DGII.
 *
 * Afirma que Contabi es emisor AUTORIZADO, que es una condición verificable: quien lo dude puede
 * cotejar el RNC en el portal de la DGII. Si en algún momento el estatus deja de ser ese, este es
 * el texto que hay que corregir, no un párrafo suelto en la home.
 */
export const SELLO_DGII = {
  titulo: 'Emisor autorizado por la DGII',
  subtitulo: 'Facturación electrónica (e-CF)',
  descripcion:
    'Contabi RD está autorizado por la Dirección General de Impuestos Internos para la emisión de comprobantes fiscales electrónicos. Cada e-CF que emites se firma digitalmente y se envía a la DGII desde la plataforma.',
};

/**
 * Logo institucional de la DGII, en `public/dgii-logo.svg`.
 *
 * Es el vectorial oficial tomado del propio portal de la DGII (dgii.gov.do), con sus colores sin
 * alterar. Es una marca institucional: se usa tal cual, no se recolorea ni se deforma.
 */
export const DGII_LOGO_SRC = '/dgii-logo.svg';

/**
 * Logo de Contabi RD, en dos versiones. Cuál usar depende de si al lado va el nombre escrito:
 *
 * - `LOGO_SRC` (`public/Logo Contabi.png`) es la marca horizontal completa —símbolo y nombre—.
 *   Va sola, sin un título repitiendo el nombre al lado.
 * - `LOGO_ICON_SRC` (`public/Icono Logo Contabi.png`) es únicamente el símbolo. Es el que va cuando
 *   el nombre ya está escrito en texto (footer, barra lateral) o cuando no cabe más que un cuadro:
 *   favicon, avatar, el sello de una factura.
 */
export const LOGO_SRC = '/Logo%20Contabi.png';
export const LOGO_ICON_SRC = '/Icono%20Logo%20Contabi.png';
